import { useTranslation } from 'next-i18next';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { Box, FelaCSS, Text } from '@bridebook/ui';
import { IconChevron, IconImg } from '@bridebook/ui/src/icons/dynamic';
import { ViewedEndScreen } from '@bridebook/web/app-shared/lib/supplier/types';
import componentStyles from './final-screen.style';

export interface SharedTypes {
  style?: FelaCSS;
}

interface FinalScreenProps extends SharedTypes {
  isVisible?: boolean;
  finalScreenText?: string;
  imagesCount: number;
  firstImageUrl: string;
  supplierId?: string;
  onViewedEndScreen?: (opts: ViewedEndScreen) => void;
}

const FinalScreen: React.FC<FinalScreenProps> = ({
  finalScreenText,
  style,
  isVisible,
  onViewedEndScreen,
  imagesCount,
  firstImageUrl,
  supplierId,
}) => {
  const { t } = useTranslation();
  const styles = componentStyles({ style });
  const { inView, ref } = useInView({ triggerOnce: true });

  useEffect(() => {
    if ((isVisible ?? inView) && onViewedEndScreen) {
      onViewedEndScreen({
        imagesCount,
        location: 'search',
        firstImageUrl,
        ...(supplierId && { supplierId }),
      });
    }
  }, [isVisible, inView, firstImageUrl, imagesCount, onViewedEndScreen, supplierId]);

  return (
    <Box style={styles.overlay} name="lightweight-carousel-final-screen" setRef={ref}>
      <Box style={styles.linkStyle}>
        <IconImg color="white" width={42} />
        <Box style={styles.seeFullProfile}>
          <Text style={styles.seeMore}>{finalScreenText || t('supplierCard.seeProfile')}</Text>
          <Box style={styles.icon}>
            <IconChevron color="white" width={10} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FinalScreen;
